// extracted by mini-css-extract-plugin
export default {"download_task":"DownloadTask_download_task__UXwZP","rotateAnimation":"DownloadTask_rotateAnimation__5iQcK","zoom":"DownloadTask_zoom__tkJ3p"};